// Legacy bridges centralized here
// Prevents API slices or components from importing legacy modules directly

import SteelCompass from '../../../../legacy/src/js/services/SteelCompass';
import AuthStore from '../../../../legacy/src/js/stores/Auth';

export function setLegacyToken(token) {
  try {
    SteelCompass.setAuthToken(token || null);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[setLegacyToken] failed:', e);
  }
}

export function legacyLogin(authData) {
  try {
    // Normalize shape for legacy AuthStore.loginRestored
    const sessionId = authData?.sessionId || (typeof window !== 'undefined' ? localStorage.getItem('token') : null);
    const user = authData?.user && typeof authData.user === 'object' ? { ...authData.user } : {};
    const rolesFromPayload = Array.isArray(authData?.roles)
      ? authData.roles
      : Array.isArray(authData?.user?.roles)
        ? authData.user.roles
        : [];
    const incarnated = !!authData?.incarnated;

    AuthStore.loginRestored({ user, sessionId, roles: rolesFromPayload, incarnated });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[legacyLogin] failed:', e);
  }
}

export function legacyLogout() {
  try {
    if (AuthStore.logout) {
      // Swallow async errors from legacy code to prevent app crash
      Promise.resolve(AuthStore.logout()).catch((e) => {
        // eslint-disable-next-line no-console
        console.error('[legacyLogout] async failed:', e);
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('[legacyLogout] failed:', e);
  }
}
